import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  bottomSheet: {
    backgroundColor: colors.backgroundL0,
    paddingHorizontal: theme.spacing[5],
    paddingBottom: theme.spacing[7] + rt.insets.bottom,
    gap: theme.spacing[4],
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: theme.spacing[6],
  },
  headerContent: {
    flex: 1,
    paddingTop: 0,
  },
  avatarWrapper: {
    position: 'relative',
    backgroundColor: colors.backgroundL0,
    borderRadius: theme.borderRadius.xs,
    marginRight: theme.spacing[5],
  },
  lockIconWrapper: {
    position: 'absolute',
    top: -4,
    right: -4,
    backgroundColor: colors.backgroundL1Inverse,
    borderRadius: theme.borderRadius.full,
    width: 22,
    height: 22,
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputContainer: {
    marginVertical: theme.spacing[8],
    alignItems: 'center',
  },
  inputLabel: {
    marginBottom: theme.spacing[3],
    textAlign: 'center',
  },
  input: {
    borderWidth: 0,
    borderRadius: 0,
    backgroundColor: 'transparent',
    alignSelf: 'stretch',
  },
  inputText: {
    textAlign: 'center',
    fontSize: 32,
  },
  lockedIcon: {
    position: 'absolute',
  },
}));
